import {
  SAVE_RECIPIENT,
  SAVE_RECIPIENT_FAILED,
  DELETE_RECIPIENT_SUCCESS,
  DELETE_RECIPIENT_FAILED,
  SAVE_RECIPIENT_DUPLICATE
} from "../actions/types";
import { message } from "antd";

const IntialState = {
  authError: null,
  recipientDuplicate: null
};

export default (state = IntialState, action) => {
  switch (action.type) {
    case SAVE_RECIPIENT:
        message.success(`Recipients uploaded successfully`, 5);
      return state;
    case SAVE_RECIPIENT_FAILED:
        message.error(`Recipients uploaded failed`, 5);
      return state;
    case SAVE_RECIPIENT_DUPLICATE:
      return {
        ...state,
        recipientDuplicate: action.msg
      };
    case DELETE_RECIPIENT_SUCCESS:
      return state;
    case DELETE_RECIPIENT_FAILED:
      return state;
    default:
      return state;
  }
};
